// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_jp-0";
export var buttonContainer = "_jp-3";
export var cancelButton = "_jp-4";
export var headerSection = "_jp-6";
export var headerTitle = "_jp-9";
export var messageSideLeft = "_jp-1";
export var messageSideRight = "_jp-2";
export var orderNumberContainer = "_jp-7";
export var orderNumberLabel = "_jp-8";
export var submitButton = "_jp-5";